<script context="module">
	const _expansionState = {
		Capas: false,
	};
</script>

<script>
	import {
		ListItem,
		Link,
		Block,
		Row,
		Col,
		Icon,
		ListItemCell,
		Range
	} from "framework7-svelte";
	import { onMount, afterUpdate } from "svelte";
	import {
		addLayerHistoric,
		deleteLayerHistoric,
		setHistoricOpacity,
		addLayerTvector,
		setVectorOpacity,
		deleteLayerTvector,
	} from "../tools/mapboxgl/index";
	import {
		setConfigTree,
		setToolTree,

	} from "../components/tree/tree-data";
	import { treeTools } from "../components/tree/tree-store";
	import { createEventDispatcher } from "svelte";
	export let tree;
	const dispatch = createEventDispatcher();
	function onMessage() {
		dispatch("message", {
			text: "Hello!",
		});
	}

	let container;
	let {
		label,
		children,
		layer,
		name,
		annio,
		group,
		title,
		id,
		outline,
		titletree,
	} = tree;
	let expanded = _expansionState[label] || false;
	const toggleExpansion = () => {
		expanded = _expansionState[label] = !expanded;
	};
	function handleBoth() {
		toggleExpansion();
		onMessage()
  }
	$: arrowDown = expanded;
	afterUpdate(() => {
		if (container.querySelector(".item-inner") !== null) {
			container.querySelector(".item-inner").style =
				"padding-top: 10px;padding-bottom: 0px;";
		}
		if (container.querySelector(".treeview-item-content") !== null) {
		}
		if (container.querySelector(".treeview-item-content") !== null) {
		}
	});
	onMount(() => {

	});
</script>

<ul style="margin-left: 5px;" bind:this={container}>
	<!-- transition:slide -->
	<li  style="margin-left: 5px;">
		{#if children}
			<span on:click={handleBoth}>
				<span class="arrow" class:arrowDown>&#x25b6</span>
				{#if titletree !== undefined}
					<span
						style="color: {$treeTools.filter(
							(item) => item.selected === true
						) !== undefined
							? $treeTools.filter(
									(item) => item.selected === true
							  ).length > 0
								? 'cornflowerblue'
								: 'white'
							: 'white'};">{label}</span
					>
				{:else if title !== undefined}
					<span
						style="color: {$treeTools.filter(
							(item) => item.group === group
						) !== undefined
							? $treeTools.filter(
									(item) =>
										item.selected === true &&
										item.group === group
							  ).length > 0
								? 'cornflowerblue'
								: 'white'
							: 'white'};">{label}</span
					>
				{:else}
					<span
						style="color: {$treeTools.filter(
							(item) => item.group === group
						) !== undefined
							? $treeTools.filter(
									(item) =>
										item.annio === label &&
										item.selected === true &&
										item.group === group
							  ).length > 0
								? 'cornflowerblue'
								: 'white'
							: 'white'};">{label}</span
					>
				{/if}
			</span>
			{#if expanded}
				{#each children as child}
					<svelte:self tree={child} />
				{/each}
			{/if}
		{:else}
			<span id= "{layer}" on:click={onMessage}>
				<span class="no-arrow" />
				<div
					class="{layer} treeview-item-content"
					style="height: {$treeTools.find(
						(item) => item.layer === layer
					) !== undefined
						? $treeTools.find((item) => item.layer === layer)[
								'config'
						  ]
							? '100'
							: '35'
						: '35'}px;"
				>
					<Block style="padding: 0px;">
						<Row noGap>
							<Col width="75">
								<ListItem
									style="width: 169px;"
									checkbox
									name="demo-checkbox"
									onChange={(e) => {
										if (e.target.checked) {

											if (group === "pcalor") {
												addLayerHistoric(layer);
											} else if (group === "aquemadas") {
												addLayerTvector(layer);
											}
											setConfigTree(
												layer,
												"selected",
												true
											);
											setConfigTree(
												layer,
												"identify",
												true
											);
											setToolTree(
												layer,
												"selected",
												true
											);
											setToolTree(
												layer,
												"identify",
												true
											);

											setToolTree(layer, "config", false);
											setToolTree(layer, "annio", annio);
											setToolTree(layer, "group", group);
											setToolTree(layer, "id", id);
											setToolTree(layer, "name", name);

											outline !== undefined
												? setToolTree(
														layer,
														"outline",
														outline
												  )
												: setToolTree(
														layer,
														"outline",
														false
												  );
										} else {
											if (group === "pcalor") {
												deleteLayerHistoric(layer);
											} else if (group === "aquemadas") {
												deleteLayerTvector(layer);
											}
											setConfigTree(
												layer,
												"selected",
												false
											);
											setConfigTree(
												layer,
												"identify",
												false
											);
											setToolTree(
												layer,
												"selected",
												false
											);
											setToolTree(
												layer,
												"identify",
												false
											);
											setToolTree(layer, "config", false);

										}
									}}
									divider={false}
									checked={$treeTools.find(
										(item) => item.layer === layer
									) !== undefined
										? $treeTools.find(
												(item) => item.layer === layer
										  )["selected"]
											? true
											: false
										: false}
								>
									<div slot="title">
										<i
											class="icon f7-icons"
											style="color: {$treeTools.find(
												(item) => item.layer === layer
											) !== undefined
												? $treeTools.find(
														(item) =>
															item.layer ===
																layer &&
															item.group === group
												  )['selected']
													? 'dodgerblue'
													: 'white'
												: 'white'};font-size: 21px; width: 21px; height: 21px;"
											>layers
										</i>
										<p
											style="color: {$treeTools.find(
												(item) => item.layer === layer
											) !== undefined
												? $treeTools.find(
														(item) =>
															item.layer ===
																layer &&
															item.group === group
												  )['selected']
													? 'dodgerblue'
													: 'white'
												: 'white'};float: right;margin-top: 2px;margin-left: 4px;"
										>
											{label}
										</p>
									</div>
									<div slot="root">
										{#if $treeTools.find((item) => item.layer === layer) !== undefined}
											{#if $treeTools.find((item) => item.layer === layer)["selected"]}
												{#if $treeTools.find((item) => item.layer === layer)["config"]}
													<ListItem
														style="left: 30px;"
													>
														<Row noGap>
															<Col width="15">
																<ListItemCell
																	class="width-auto"
																>
																	<Icon
																		ios="f7:sun_min"
																		aurora="f7:sun_min"
																		md="f7:sun_min"
																	/>
																</ListItemCell>
															</Col>
															<Col
																width="50"
																style="margin-top: 3px;"
															>
																<ListItemCell>
																	<Range
																		min={0}
																		max={100}
																		step={1}
																		value={$treeTools.find(
																			(
																				item
																			) =>
																				item.layer ===
																				layer
																		)[
																			"opacity"
																		]}
																		label={true}
																		onRangeChange={(
																			val
																		) => {
																			setToolTree(
																				layer,
																				"opacity",
																				val
																			);
																			if (
																				group ===
																				"pcalor"
																			) {
																				setHistoricOpacity(
																					layer,
																					val /
																						100
																				);
																			} else if (
																				group ===
																				"aquemadas"
																			) {
																				setVectorOpacity(
																					layer,
																					val /
																						100
																				);
																			}
																		}}
																	/>
																</ListItemCell>
															</Col>
															<Col width="15">
																<ListItemCell
																	class="width-auto flex-shrink-0"
																>
																	<Icon
																		ios="f7:sun_max_fill"
																		aurora="f7:sun_max_fill"
																		md="f7:sun_max_fill"
																	/>
																</ListItemCell>
															</Col>
														</Row>
													</ListItem>
												{/if}
											{/if}
										{/if}
									</div>
								</ListItem>
							</Col>
							<Col width="10">
								{#if $treeTools.find((item) => item.layer === layer) !== undefined}
									{#if $treeTools.find((item) => item.layer === layer)["selected"]}
										{#if $treeTools.find((item) => item.layer === layer)["identify"]}
											<Link
												style="margin-top: 15px;"
												iconSize="21px"
												tooltip="Identificar objetos espaciales"
												iconIos="f7:info_circle_fill"
												iconAurora="f7:info_circle_fill"
												iconMd="f7:info_circle_fill"
												on:click={() => {
													setToolTree(
														layer,
														"identify",
														false
													);
												}}
											/>
										{:else}
											<Link
												style="margin-top: 15px;"
												iconSize="21px"
												tooltip="Identificar objetos espaciales"
												iconIos="f7:info_circle"
												iconAurora="f7:info_circle"
												iconMd="f7:info_circle"
												on:click={() => {
													setToolTree(
														layer,
														"identify",
														true
													);
												}}
											/>
										{/if}
									{/if}
								{/if}
							</Col>
							<Col width="10">
								{#if $treeTools.find((item) => item.layer === layer) !== undefined}
									{#if $treeTools.find((item) => item.layer === layer)["selected"]}
										{#if $treeTools.find((item) => item.layer === layer)["config"]}
											<Link
												style="margin-top: 15px;"
												iconSize="21px"
												tooltip="Configurar capa"
												iconIos="f7:gear_alt_fill"
												iconAurora="f7:gear_alt_fill"
												iconMd="f7:gear_alt_fill"
												on:click={() => {
													setToolTree(
														layer,
														"config",
														false
													);
												}}
											/>
										{:else}
											<Link
												style="margin-top: 15px;"
												iconSize="21px"
												tooltip="Configurar capa"
												iconIos="f7:gear_alt"
												iconAurora="f7:gear_alt"
												iconMd="f7:gear_alt"
												on:click={() => {
													setToolTree(
														layer,
														"config",
														true
													);
												}}
											/>
										{/if}
									{/if}
								{/if}
							</Col>
						</Row>
					</Block>
				</div>
			</span>
		{/if}
	</li>
</ul>

<style>
	.list .item-inner {
		padding-top: 0px !important;
	}
	ul {
		margin: 0;
		list-style: none;
		padding-left: 1.2rem;
		user-select: none;
	}
	input {
		margin-right: 5px;
	}
	.no-arrow {
		/* padding-left: 1.0rem;  */
	}
	.treeview-item-content {
		padding-left: 0px; /*height: 35px;*/
	}
	.arrow {
		cursor: pointer;
		display: inline-block;
		/* padding-left: 1.0rem; */
		transition: transform 200ms;
	}
	.arrowDown {
		transform: rotate(90deg);
	}
</style>
